import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./Groupedview.scss";
import classNames from "classnames";
import I18nHOC from "UIComponents/I18nHOC";
import AnimateHeight from "UIComponents/AnimateHeight";
import BenchmarkView from "UIComponents/BenchmarkView";
import { getLabelWithArchivedText } from "Utils";
import { CaretUpFilled, CaretDownFilled } from "@toddle-edu/ds-icons";
class Groupedview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isEnable: props.isDefaultEnabled,
    };
  }

  onCheckboxClicked = selectedValues => {
    const {
      props: { nodes, parentNode },
    } = this;

    this.props.onItemSelected({
      selections: selectedValues,
      nodes,
      parentNode,
    });
  };

  onAccordianClick = () => {
    const { isDefaultEnabled } = this.props;
    if (!isDefaultEnabled) {
      this.setState({ isEnable: !this.state.isEnable });
    }
  };

  render() {
    const {
      props: {
        selectedValues,
        parentNode,
        nestedGroupedValue,
        readOnly,
        isDefaultEnabled,
        mainContainerStyle,
        headerContainerStyle,
        headerLabelStyle,
        banchmarksContainerStyle,
        mainContentContainerStyle,
        childrenContainerStyle,
        rootNodeDepth,
        showHeader,
        dynamicLevelContainerStyle,
        t,
      },
      state: { isEnable },
    } = this;

    const numOfSelectedValues = _.get(selectedValues, "length", 0);
    const selectedNumberString =
      numOfSelectedValues > 0 ? ` (${numOfSelectedValues})` : "";

    const arrowStyle = classNames(
      { [classes.arrowContainer]: true },
      { [classes.openArrow]: isEnable },
      { [classes.closeArrow]: !isEnable }
    );

    const titleStyle = classNames(
      { [classes.headerLabel]: true },
      { [classes.headerLabelOpen]: isEnable }
    );

    const parentNodeLabel = getLabelWithArchivedText({
      label: `${parentNode.label}${selectedNumberString}`,
      isArchived: parentNode?.isArchived,
      t,
    });

    return (
      <div className={classes.mainContainer} style={mainContainerStyle}>
        {showHeader && (
          <div
            className={classes.headerContainer}
            style={headerContainerStyle}
            onClick={this.onAccordianClick}
          >
            <div className={titleStyle} style={headerLabelStyle}>
              {parentNodeLabel}
            </div>
            {!isDefaultEnabled && (
              <div className={arrowStyle}>
                {isEnable ? (
                  <CaretUpFilled size={"x-small"} variant="subtle" />
                ) : (
                  <CaretDownFilled size={"x-small"} variant="subtle" />
                )}
              </div>
            )}
          </div>
        )}

        <div
          className={classes.banchmarksContainer}
          style={banchmarksContainerStyle}
        >
          <AnimateHeight
            duration={300}
            height={isEnable || readOnly ? "auto" : 0}
            style={{ width: "100%" }}
          >
            <div
              className={classes.mainContentContainer}
              style={mainContentContainerStyle}
            >
              <BenchmarkView
                value={nestedGroupedValue}
                startDepth={rootNodeDepth}
                mode={"view"}
                isTagging={true}
                updateInputField={this.onCheckboxClicked}
                selectedValues={selectedValues}
                childrenContainerStyle={childrenContainerStyle}
                dynamicLevelContainerStyle={dynamicLevelContainerStyle}
              ></BenchmarkView>
            </div>
          </AnimateHeight>
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: ["common"] })(Groupedview);

Groupedview.defaultProps = {
  isDefaultEnabled: false,
  showHeader: true,
};
